import EmojiPicker from 'emoji-picker-react';
import { SkinTonePickerLocation, SuggestionMode } from 'emoji-picker-react';
import useWindowDimensions from './windowHelper';
import Modal from '@mui/material/Modal';
import { useTheme } from '@mui/material/styles';

const EmojiPickerModal = ({ showEmojiPicker, onEmojiClick, onClose }) => {
    const { width, height } = useWindowDimensions();
    const theme = useTheme();
    const pickerWidth = Math.min(width, 480) - 40;

    return (
        <Modal
            open={showEmojiPicker}
            onClose={onClose}
        >
            <div role='dialog' aria-label='Choose an emoji for your list' tabIndex={-1}
                style={{ width: pickerWidth, margin: '20px auto', outline: 'none' }}>
                <EmojiPicker
                    theme={theme.palette.mode}
                    suggestedEmojisMode={SuggestionMode.RECENT}
                    skinTonePickerLocation={SkinTonePickerLocation.SEARCH}
                    height={`${height * 0.9}px`}
                    width={`${pickerWidth}px`}
                    previewConfig={{ showPreview: false }}
                    searchPlaceholder="Pick an emoji for your list..."
                    onEmojiClick={onEmojiClick}
                    autoFocusSearch={false}
                />
            </div>
        </Modal>
    );
};

export default EmojiPickerModal;
